import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message", "className", "children", "messageOptions"];
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import styled from 'styled-components';
import { H3 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledStepSubtitle = styled(H3).withConfig({
  displayName: "StepSubtitle__StyledStepSubtitle",
  componentId: "awd8z4-0"
})(["font-size:22px;font-weight:400;", ""], props => props.theme.embedded && `text-align: center;
  margin-bottom: 0;`);
export const StepSubtitle = _ref => {
  let {
      message = '',
      className = '',
      children,
      messageOptions
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (message && isValidI18nKey(message)) {
    return /*#__PURE__*/_jsxs(StyledStepSubtitle, Object.assign({
      className: className
    }, rest, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message,
        options: messageOptions
      }), children]
    }));
  }
  return null;
};